import { api } from "./api";
import { TLanguage, TLanguageCulture, TLocale } from "../../types/types";

export const languagesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCurrentLocales: build.query<TLocale, void>({
      query: () => "/Languages/getCurrentLocales",
    }),
    getLanguages: build.query<TLanguage[], void>({
      query: () => ({
        url: "/Languages/",
        method: "GET",
      }),
      providesTags: ["language"],
    }),
    getAllCultures: build.query<TLanguageCulture[], void>({
      query: () => "/Languages/GetAllCultures",
    }),
    addLanguage: build.mutation<boolean, TLanguageCulture>({
      query: (newLanguage) => ({
        url: "/Languages/",
        method: "POST",
        body: newLanguage,
      }),
      invalidatesTags: ["language"],
    }),
    updateLanguage: build.mutation<boolean, { updatedLanguage: TLanguage; type: number }>({
      query: ({updatedLanguage,type}) => ({
        url: `/Languages/Admin_Update_Language/${type}`,
        method: "POST",
        body: updatedLanguage,
      }),
      invalidatesTags: ["language"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCurrentLocalesQuery,
  useGetLanguagesQuery,
  useAddLanguageMutation,
  useGetAllCulturesQuery,
  useUpdateLanguageMutation
} = languagesApi;
